const settingsConfig = (settingsService, bootstrap) => {
    settingsService.updateSettings(bootstrap.getBootstrappedData(bootstrap.bootstrapped.Settings));
};

settingsConfig.$inject = ['SettingsService', 'BootstrapService'];

module.exports = settingsConfig;



// WEBPACK FOOTER //
// ./src/common/settings/settings.config.js